// extracted by mini-css-extract-plugin
module.exports = {"container":"Sidebar_container__ruLA9"};